export const auditFieldMap = {
  vehicles: {
    busNumber: "Bus Number",
    vehicleNumber: "Registration Number",
    brand: "Brand",
    model: "Model",
    color: "Color",
    capacity: "Capacity",
    useTelematic: "Telematics",
    status: "Status",
  },
  drivers: {
    email: "Email",
    name: "Name",
    preferredName: "Preferred Name",
    phoneNumber: "Phone Number",
    type: "Type",
    profileImage: "Profile Image",
    status: "Status",
    passwordChange: "Password Change"
  },
  campaigns: {
    name: "Campaign Name",
    description: "Description",
    message: "Message",
    targetAudience: "Target Audience",
    status: "Status",
    alertTime: "Scheduled Time",
    lastTriggered: "Campaign Last Triggered",
  },
  admins: {
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    role: "Role",
  },
  families: {
    familyId: "Family ID"
  },
  parents: {
    email: "Email",
    firstName: "First Name",
    lastName: "Last Name",
    preferredName: "Preferred Name",
    phoneNumber: "Phone Number",
    address: "Address",
    emailOnboardStatus: "Onboarding Email",
    phoneNotifications: "Phone Notifications",
  },
  childs: {
    firstName: "First Name",
    lastName: "Last Name",
    preferredName: "Preferred Name",
    grade: "Grade",
    class: "Class",
    dob: "Date of Birth",
    alightPermission: "Permission to Alight",
    childImg: "Child Image",
    comment: "Alighting Comment",
    note: "Note",
    preferences: "Preferences"
  },
  stops: {
    name: "Name",
    type: "Type",
    description: "Description",
    address: "Address",
    location: "Location",
    status: "Status",
    associatedChilds: "Associated Students"
  },
  trips: {
    name: "Name",
    startTime: "Start Time",
    triptypeName: "Type",
    status: "Status",
    stopsArray: "Included Stops",
  },
  schedules: {
    tripDetails: "Trip",
    driverDetails: "Driver",
    assistantDetails: "Assistant",
    vehicleDetails: "Vehicle",
    scheduleDate: "Scheduled Date",
    startTime: "Start Time",
    totalStudents: "Number of Students",
    stopsArray: "Included Stops",
    schedules: "Schedule Status",
    affectedStudents: "Affected Students",
  },
  deeplinks: {
    url: "URL",
    label: "Label",
    institutionIds: "Linked Institutions",
  },
  contents: {
    type: "Content Type",
    title: "Title",
    version: "Version",
    icon: "Icon",
    titleColor: "Header Colour",
    content: "Content",
    isActive: "Active",
  },
};

export const adminModuleFieldMap = {
  mapOverview: "Map Overview",
  dispatchBoard: "Dispatch Board",
  routeManagement: "Route Management",
  administrators: "Administrators",
  familyManagement: "Family Management",
  campaignManagement: "Campaign Management",
  vehicles: "Vehicles",
  drivers: "Drivers",
  scheduling: "Scheduling",
};

export const ADMIN_ROLES_WITH_MODULES = ["EDITOR", "VIEWER"];

export const ignoredFields = {
  campaigns: {
    CREATE: ["lastTriggered"],
    UPDATE: [],
    DELETE: ["targetAudience"],
  },
  admins: {
    CREATE: ["lastTriggered"],
    UPDATE: ["email"],
    DELETE: [],
  },
  drivers: {
    CREATE: ["passwordChange"],
    UPDATE: [],
    DELETE: ["passwordChange"],
  },
  trips: {
    CREATE: ["type"],
    UPDATE: ["type"],
    DELETE: ["type"],
  },
  parents: {
    UPDATE: ["fcmToken"],
  },
};
